/* Native dialogs keep keyboard focus within the open panel; Shopify handles signup. */
(() => {
 'use strict';
 const welcome=document.querySelector('[data-welcome-dialog]');
 const subscription=document.querySelector('[data-subscription-dialog]');
 const read=(key)=>{try{return localStorage.getItem(key);}catch{return null;}};
 const write=(key,value)=>{try{localStorage.setItem(key,value);}catch{/* Storage may be disabled. */}};
 const session=(key,value)=>{try{if(value!==undefined)sessionStorage.setItem(key,value);return sessionStorage.getItem(key);}catch{return null;}};
 const signal=()=>document.dispatchEvent(new CustomEvent('phos:dialog'));
 let restoreFocus=null,previousOverflow='';
 const show=(dialog)=>{
  if(!dialog || dialog.open || document.querySelector('dialog[open]'))return;
  restoreFocus=document.activeElement;previousOverflow=document.body.style.overflow;
  dialog.showModal();if(dialog===welcome)session('phos-welcome-seen','true');document.body.style.overflow='hidden';signal();
 };
 [welcome,subscription].filter(Boolean).forEach(dialog=>{
  dialog.querySelectorAll('[data-dialog-close]').forEach(button=>button.addEventListener('click',()=>dialog.close()));
  dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();});
  dialog.addEventListener('close',()=>{document.body.style.overflow=previousOverflow;if(dialog===welcome)write('phos-welcome-dismissed',String(Date.now()));if(restoreFocus?.isConnected)restoreFocus.focus();signal();});
 });
 document.addEventListener('click',event=>{
  if(event.target.closest('[data-welcome-open]')&&welcome){event.preventDefault();show(welcome);}
  if(event.target.closest('[data-subscription-open]')&&subscription){event.preventDefault();show(subscription);}
 });
 if(!welcome)return;
 const form=welcome.querySelector('form');
 document.querySelector('#NewsletterForm')?.addEventListener('submit',()=>session('phos-newsletter-submitting',String(Date.now())));
 const newsletterSubmitted=Number(session('phos-newsletter-submitting'));
 if(newsletterSubmitted&&Date.now()-newsletterSubmitted<15*60*1000&&document.querySelector('#NewsletterForm .newsletter-success')){write('phos-welcome-complete','true');session('phos-newsletter-submitting','');}
 form?.addEventListener('submit',()=>{session('phos-welcome-submitting',String(Date.now()));});
 const submittedAt=Number(session('phos-welcome-submitting'));
 if(submittedAt && Date.now()-submittedAt<15*60*1000 && (welcome.querySelector('[data-welcome-success]')||welcome.querySelector('[data-welcome-error]'))){
  show(welcome);session('phos-welcome-submitting','');
  if(welcome.querySelector('[data-welcome-success]'))write('phos-welcome-complete','true');
  return;
 }
 if(welcome.dataset.auto!=='true'||read('phos-welcome-complete')||Date.now()-Number(read('phos-welcome-dismissed'))<7*86400000||session('phos-welcome-seen'))return;
 let ready=false,shown=false,retry;
 const attempt=()=>{
  clearTimeout(retry);
  if(!ready||shown||document.hidden)return;
  if(read('phos-welcome-complete')||Date.now()-Number(read('phos-welcome-dismissed'))<7*86400000||session('phos-welcome-seen')){document.removeEventListener('visibilitychange',attempt);return;}
  const cookie=document.querySelector('#shopify-pc__banner');
  const busy=document.querySelector('dialog[open],[data-cart-drawer].open,.nav-mobile.open')||document.activeElement?.matches('input,select,textarea')||(cookie&&cookie.getClientRects().length);
  if(busy){retry=setTimeout(attempt,500);return;}
  shown=true;session('phos-welcome-seen','true');show(welcome);
  document.removeEventListener('visibilitychange',attempt);
 };
 setTimeout(()=>{ready=true;attempt();},Math.max(1,Number(welcome.dataset.delay)||5)*1000);
 document.addEventListener('visibilitychange',attempt);
})();
